import * as Sentry from "@sentry/browser";
import { isEmpty } from "utils/helper/common";
import { getLogRocketSessionURL, initLogRocket } from "utils/helper/logRocket";

let logRocketSessionURL = null;

const attachLogRocketSessionURL = event => {
  if (!logRocketSessionURL) {
    return event;
  }

  return {
    ...event,
    extra: {
      ...event.extra,
      LogRocket: logRocketSessionURL,
      sessionURL: logRocketSessionURL
    }
  };
};

const shouldTriggerLogRocketTestError = () => {
  if (typeof window === "undefined") return false;

  return (
    new URLSearchParams(window.location.search).get("logrocket_test") === "1"
  );
};

const triggerLogRocketTestError = () => {
  setTimeout(() => {
    throw new Error("LogRocket error UAT test");
  }, 0);
};

export default function setupLogService() {
  // 本番ビルドのみログ送信
  if (MODE === "production" && ENABLE_LOG_SERVICE) {
    logRocketSessionURL = null;
    const shouldTestLogRocket = shouldTriggerLogRocketTestError();

    initLogRocket(LOGROCKET_APP_ID, {
      network: {
        requestSanitizer: request => {
          // /auth API のパスワード入力を秘匿
          if (request.url.indexOf("/auth") !== -1) {
            const params = JSON.parse(request.body);
            Object.keys(params).forEach(key => {
              if (
                (key === "j_password" || key === "enforcePassword") &&
                !isEmpty(params[key])
              ) {
                params[key] = "*****";
              }
            });
            request.body = JSON.stringify(params);
          }
          return request;
        }
      }
    }).then(() => {
      // 明示トリガー時だけ LogRocket/Sentry の動作確認用エラーを発生させる
      if (shouldTestLogRocket) triggerLogRocketTestError();
    });

    // Sentry 起動
    Sentry.init({
      dsn: SENTRY_DSN,
      release: SENTRY_RELEASE,
      beforeSend: attachLogRocketSessionURL
    });

    // Sentry と LogRocket 紐づけ
    getLogRocketSessionURL(sessionURL => {
      logRocketSessionURL = sessionURL;
      Sentry.configureScope(scope => {
        scope.setExtra("sessionURL", sessionURL);
      });
    });
  }
}
